import { withValidation } from './Validation';
import { createInputId } from '../../utils/utilities';
import TextInput from '../Inputs/TextInput';

const QuestionTextbox = props => {
    const {
        value,
        label,
        handleChange,
        required,
        helperText,
        name,
        type = 'text'
    } = props;

    const errorStyle = helperText ? 'flex flex-col [&_#text-input-container]:!ring-cherry-red' : 'flex flex-col'

    return (
        <div className={errorStyle}>
            <h6 className='text-base m-0 font-normal' id={name}>
                {label} {required ? <span className='text-cherry-red'>*</span>: null}
            </h6>

            <TextInput
                id={createInputId(name)}
                value={value || ''}
                onChange={handleChange}
                type={type}
            />

            {helperText && <p data-testid='text-input-error' className='text-cherry-red m-0 text-sm mt-2'>{helperText}</p>}
        </div>
    );
}

export default withValidation(QuestionTextbox);
